import PropTypes from 'prop-types';
import React from 'react';

import { QuaternaryHeading } from 'components/Headings';
import { TYPES } from 'constants/topNavigation';

const Level2Header = ({
  l1Label,
  title,
  href,
  trackNavigation,
  trackNavigationClick,
  ...otherProps
}) => {
  const handleClick = () => {
    trackNavigation(href);
    trackNavigationClick({
      navigationType: TYPES.LEVEL_2,
      navigationLevel1: l1Label,
      navigationLevel2: title,
      navigationSource: window.location.href,
    });
  };

  return (
    <>
      {href ? (
        <a href={href} className="Level2Header" {...otherProps} onClick={() => handleClick()}>
          <div className="Level2Header__content">
            <QuaternaryHeading>{title}</QuaternaryHeading>
          </div>
        </a>
      ) : (
        <div className="Level2Header--no-link">
          <QuaternaryHeading>{title}</QuaternaryHeading>
        </div>
      )}
      <style jsx>
        {`
          .Level2Header,
          .Level2Header--no-link {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            text-decoration: none;
          }

          .Level2Header--no-link {
            cursor: default;
          }

          .Level2Header__content:hover {
            text-decoration: underline;
          }
        `}
      </style>
    </>
  );
};

Level2Header.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string,
  trackNavigation: PropTypes.func,
  trackNavigationClick: PropTypes.func,
  l1Label: PropTypes.string,
};

Level2Header.defaultProps = {
  href: undefined,
  trackNavigation: undefined,
  l1Label: '',
  trackNavigationClick: () => {},
};

export default Level2Header;
